// Centralized real-world content for Fortuna Ponyva Kft.

export const COMPANY = {
  name: "Fortuna Ponyva Kft.",
  shortName: "Fortuna Ponyva",
  motto: "A jó minőségű ponyva nem szerencse dolga.",
  experienceYears: 20,
  phone: "+36 24 510 280",
  phoneRaw: "+3624510280",
  email: "info@fortunaponyva.hu",
  address: "2330 Dunaharaszti, Jedlik Ányos út 10.",
  addressShort: "Dunaharaszti, Jedlik Ányos út 10.",
  hours: [
    { d: "Hétfő – Péntek", h: "07:00 – 16:00" },
    { d: "Szombat", h: "Egyeztetés alapján" },
    { d: "Vasárnap", h: "Zárva" },
  ],
  facebook: "https://www.facebook.com/Fortunaponyva.hu/",
  googleReviews: "https://g.co/kgs/xS1KQsE",
  mapEmbed:
    "https://www.google.com/maps?q=2330+Dunaharaszti,+Jedlik+%C3%81nyos+%C3%BAt+10&output=embed",
};

// Premium hero stock image (industrial trucks at sunset, Unsplash editorial)
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=2400&q=80";

// Mega menu navigation grouped by category
export const NAV_GROUPS = [
  {
    label: "Gyártás",
    icon: "Hammer",
    items: [
      { to: "/jarmuponyva-keszites", label: "Járműponyva-készítés", desc: "Teherautó, kamion, utánfutó" },
      { to: "/egyedi-ponyvak", label: "Egyedi ponyvák", desc: "Speciális, méretre szabott megoldások" },
      { to: "/medence-ponyvak", label: "Medenceponyvák", desc: "Bélés és takaró ponyvák" },
      { to: "/satrak-mobilraktarak", label: "Sátrak és mobilraktárak", desc: "ADR ponyva, fixvázas sátrak" },
      { to: "/vasszerkezeti-munkak", label: "Vasszerkezeti munkák", desc: "Egyedi tartószerkezetek" },
      { to: "/eloteto-arnyekolo", label: "Előtető, árnyékoló", desc: "Terasz, vendéglátó, otthon" },
      { to: "/terasz-teliesites", label: "Terasz-téliesítés", desc: "Oldalfal, ablak, ponyva" },
      { to: "/ponyva-mobil-garazs", label: "Mobil garázs", desc: "Harmonika rendszerű garázs" },
    ],
  },
  {
    label: "Javítás & Szerviz",
    icon: "Wrench",
    items: [
      { to: "/jarmu-ponyva-javitas", label: "Járműponyva-javítás", desc: "Szakadás, hegesztés, átalakítás" },
      { to: "/ponyva-tisztitas-felujitas", label: "Tisztítás, felújítás", desc: "Profi mosás" },
      { to: "/karpitos-borozes", label: "Kárpitos és bőrözési munkák", desc: "Belsőtér, ülés, kabrió" },
      { to: "/ponyva-kiegeszitok", label: "Ponyva kiegészítők", desc: "Heveder, ringli, fül, görgő" },
    ],
  },
  {
    label: "Dekoráció & Nyomtatás",
    icon: "Palette",
    items: [
      { to: "/reklamdekoracio", label: "Reklámdekoráció", desc: "Mozgóreklám haszongépjárműre" },
      { to: "/digitalis-nyomtatas", label: "Digitális nyomtatás", desc: "PVC ponyvára és vinylre" },
      { to: "/dekoracio-eltavolitas", label: "Dekorációeltávolítás", desc: "Régi grafika levétele" },
    ],
  },
  {
    label: "Termékek & Anyagok",
    icon: "Layers",
    items: [
      { to: "/hasznalt-ponyvak", label: "Használt ponyvák", desc: "Több száz darab raktáron" },
      { to: "/ponyvak-es-szinek", label: "Ponyvák és színek", desc: "Többféle szín, prémium gyártók" },
      { to: "/akciok", label: "Aktuális akcióink", desc: "Csomagajánlatok és kedvezmények" },
    ],
  },
];

// Featured CTA inside mega menu
export const MEGA_FEATURE = {
  to: "/akciok",
  badge: "Aktuális",
  title: "Akcióink",
  desc: "Ingyenes állapotfelmérés, beszámítás, 10+1 használt ponyva, medence csomag.",
  cta: "Akciók megtekintése",
};

// Flat list of all subpage links (for footer / sitemap / mobile menu)
export const NAV_LINKS = NAV_GROUPS.flatMap((g) => g.items);

// Featured services for Home grid (top 8)
export const SERVICES = [
  {
    id: "jarmuponyva-keszites",
    slug: "/jarmuponyva-keszites",
    title: "Járműponyva-készítés",
    short: "Teherautó, kamion és utánfutó ponyvák egyedi méretre, belga és német alapanyagból.",
    image:
      "/assets/gallery/palletways-01.jpg",
  },
  {
    id: "jarmu-ponyva-javitas",
    slug: "/jarmu-ponyva-javitas",
    title: "Járműponyva-javítás",
    short: "Szakadás, sérülés, átalakítás – garanciával.",
    image:
      "/assets/gallery/palletways-02.jpg",
  },
  {
    id: "reklamdekoracio",
    slug: "/reklamdekoracio",
    title: "Reklámdekoráció",
    short: "Haszongépjárművek, transzparensek, molinók – tervezés és kivitelezés.",
    image:
      "/assets/gallery/lasi-01.jpg",
  },
  {
    id: "satrak-mobilraktarak",
    slug: "/satrak-mobilraktarak",
    title: "Sátrak és mobilraktárak",
    short: "Fixvázas előtetők, rendezvény- és raktársátrak ADR-ponyvából.",
    image:
      "/assets/gallery/egyedi-01.jpg",
  },
  {
    id: "eloteto-arnyekolo",
    slug: "/eloteto-arnyekolo",
    title: "Előtető, árnyékoló",
    short: "Teraszárnyékolók és napellenzők PVC ponyvából.",
    image:
      "/assets/gallery/terasz-telisites.jpg",
  },
  {
    id: "medence-ponyvak",
    slug: "/medence-ponyvak",
    title: "Medenceponyvák",
    short: "Bélés (víztartó) és takaró ponyvák, méretpontos cserék.",
    image:
      "/assets/gallery/medence.jpg",
  },
  {
    id: "terasz-teliesites",
    slug: "/terasz-teliesites",
    title: "Terasz-téliesítés",
    short: "Ablakos/ablak nélküli oldalfal, hideg elleni teljes burkolás.",
    image:
      "/assets/gallery/terasz-telisites.jpg",
  },
  {
    id: "hasznalt-ponyvak",
    slug: "/hasznalt-ponyvak",
    title: "Használt ponyvák",
    short: "Több száz darab raktáron – azonnal elvihető, kedvező áron.",
    image:
      "/assets/gallery/palletways-03.jpg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Zsolt",
    text: "Nagyon korrekt, segítőkész emberek dolgoznak e helyen mind az irodában, mind a javítási részlegen.",
  },
  {
    name: "János",
    text: "Teljesen profik, s nagyon szépen, pontosan dolgoznak!",
  },
  {
    name: "Annamária",
    text: "Kedves, hozzáértő személyzet! Gyors, pontos, tartós munka. Náluk nincs lehetetlen dolog!",
  },
];

export const STATS = [
  { value: "20+", label: "év szakmai tapasztalat" },
  { value: "5000+", label: "elkészített ponyva" },
];

// Frequently asked questions
export const FAQ = [
  {
    q: "Mennyi idő alatt készül el egy új teherautó ponyva?",
    a: "Egy teljes oldal- és tetőponyva általában 3–5 munkanap alatt elkészül a méretvételtől számítva, az aktuális megrendelésállománytól függően. Egyedi esetekben több időt vehet igénybe a gyártás.",
  },
  {
    q: "Milyen alapanyagokból dolgoznak?",
    a: "Belga (Sioen, Sauleda), német (Mehler), osztrák és spanyol gyártású prémium PVC ponyvákkal dolgozunk, többféle g/m² súlyban. Raktárunkon széles színválaszték elérhető.",
  },
  {
    q: "Adnak garanciát?",
    a: "Minden munkánkra vállalunk garanciát. Ritkán, de adódhatnak kivételt képző esetek, melyet előre jelzünk.",
  },
  {
    q: "Mi a méretvétel menete?",
    a: "Az állapotfelmérés, méretvétel telephelyünkön 100%-ban INGYENES, kötelezettség nélkül. Pár percet vesz igénybe, ezt követően pontos árajánlatot készítünk.",
  },
  {
    q: "Hol találom a műhelyt?",
    a: "2330 Dunaharaszti, Jedlik Ányos út 10. szám alatt vagyunk, Budapest dél-pesti határától néhány perc távolságra. Könnyen elérhető az M0, M5 autópályákról és az 51-es, 5-ös útról is.",
  },
  {
    q: "Vásárolhatok használt ponyvát is?",
    a: "Igen, folyamatosan tartunk raktáron több száz darab átvizsgált, jó állapotú használt kamionponyvát. Akciónk: 10 db ponyva egyidejű vásárlása esetén egyet ajándékba adunk.",
  },
];

// Color palette (24 colors approximating the manufacturer ranges)
export const COLOR_PALETTE = [
  { name: "Bézs", hex: "#e0cfa4", code: "1001" },
  { name: "Szignálsárga", hex: "#f7ba0b", code: "1003" },
  { name: "Elefántcsont", hex: "#e1cc4f", code: "1014" },
  { name: "Világos elefántcsont", hex: "#e6d690", code: "1015" },
  { name: "Repcesárga", hex: "#f3a505", code: "1021" },
  { name: "Dinnyesárga", hex: "#f7ba0b", code: "1028" },
  { name: "Tiszta narancs", hex: "#f44611", code: "2004" },
  { name: "Borvörös", hex: "#5e2129", code: "3005" },
  { name: "Közlekedési piros", hex: "#cc0605", code: "3020" },
  { name: "Telemagenta", hex: "#cf3476", code: "4010" },
  { name: "Ultramarinkék", hex: "#20214f", code: "5002" },
  { name: "Kobaltkék", hex: "#1e2460", code: "5013" },
  { name: "Égkék", hex: "#2271b3", code: "5015" },
  { name: "Sárgászöld", hex: "#586b30", code: "6018" },
  { name: "Opálzöld", hex: "#005d52", code: "6026" },
  { name: "Achátszürke", hex: "#b5b8b1", code: "7038" },
  { name: "Teleszürke", hex: "#4b4d46", code: "7046" },
  { name: "Szépiabarna", hex: "#4a3222", code: "8014" },
  { name: "Csokoládébarna", hex: "#442f29", code: "8017" },
  { name: "Szignálfehér", hex: "#ecebe4", code: "9003" },
  { name: "Mélyfekete", hex: "#0a0a0a", code: "9005" },
  { name: "Ezüst", hex: "#999a9e", code: "9022" },
];

// Material brands shown on the colors page
export const MATERIAL_BRANDS = [
  { name: "Sattler", country: "Ausztria", weight: "650–900 g/m²", warranty: "10 év" },
  { name: "Mehler Haku", country: "Németország", weight: "600–900 g/m²", warranty: "10 év" },
  { name: "Sioen", country: "Belgium", weight: "650–900 g/m²", warranty: "10 év" },
  { name: "Sauleda", country: "Spanyolország", weight: "550–800 g/m²", warranty: "10 év" },
];

// Tarpaulin accessories catalogue
export const ACCESSORIES = [
  { name: "Ringli", desc: "Fémes erősítésű lyuk feszítéshez", spec: "Ø 16–22 mm" },
  { name: "Heveder", desc: "Erősített műszálas, csatos", spec: "1,3 t szakítószilárdság" },
  { name: "Fül", desc: "Hegesztett vagy csavarozott", spec: "PVC vagy fém" },
  { name: "Kampó / racsni", desc: "Rögzítéshez, hevederhez", spec: "Cinkezett acél" },
  { name: "Patent / pánt", desc: "Lefogatás, ponyva-rögzítés", spec: "5–10 cm méret" },
  { name: "Görgő rendszer", desc: "Elhúzható ponyvákhoz", spec: "Műanyag / fém" },
  { name: "Fényvisszaverő csík", desc: "ADR és láthatóság", spec: "5 cm sárga / piros" },
  { name: "Hegesztő heveder", desc: "Ipari ponyvához", spec: "PVC bevonatú" },
  { name: "Sátor függöny tartozékok", desc: "Cipzár, gomb, csat", spec: "Vario méret" },
  { name: "Szíjak / kötelek", desc: "Lekötés, áruvédelem", spec: "Műszál, 8–25 mm" },
];

// Real photos from existing site (used across pages)
export const SITE_IMAGES = {
  hero: HERO_IMAGE,
  truckGallery: [
    "/assets/gallery/teherauto-01.jpg",
    "/assets/gallery/teherauto-02.jpg",
    "/assets/gallery/teherauto-03.jpg",
    "/assets/gallery/teherauto-04.jpg",
    "/assets/gallery/palletways-01.jpg",
    "/assets/gallery/palletways-02.jpg",
    "/assets/gallery/palletways-03.jpg",
    "/assets/gallery/palletways-04.jpg",
    "/assets/gallery/palletways-05.jpg",
    "/assets/gallery/palletways-06.jpg",
    "/assets/gallery/palletways-07.jpg",
    "/assets/gallery/palletways-04.jpg",
    "/assets/gallery/palletways-05.jpg",
    "/assets/gallery/palletways-06.jpg",
    "/assets/gallery/palletways-07.jpg",
    "/assets/gallery/teherauto-01.jpg",
    "/assets/gallery/teherauto-02.jpg",
    "/assets/gallery/teherauto-03.jpg",
    "/assets/gallery/teherauto-04.jpg",
    "/assets/gallery/palletways-01.jpg",
  ],
  repairGallery: [
    "/assets/gallery/palletways-02.jpg",
    "/assets/gallery/palletways-03.jpg",
    "/assets/gallery/palletways-04.jpg",
    "/assets/gallery/palletways-05.jpg",
    "/assets/gallery/palletways-06.jpg",
    "/assets/gallery/palletways-07.jpg",
  ],
  adGallery: [
    "/assets/gallery/lasi-01.jpg",
    "/assets/gallery/lasi-02.jpg",
    "/assets/gallery/lasi-03.jpg",
    "/assets/gallery/palletways-01.jpg",
    "/assets/gallery/palletways-06.jpg",
    "/assets/gallery/palletways-07.jpg",
  ],
  tentGallery: [
    "/assets/gallery/egyedi-01.jpg",
    "/assets/gallery/egyedi-02.jpg",
    "/assets/gallery/egyedi-03.jpg",
    "/assets/gallery/egyedi-04.jpg",
    "/assets/gallery/egyedi-05.jpg",
    "/assets/gallery/egyedi-02.jpg",
    "/assets/gallery/egyedi-03.jpg",
    "/assets/gallery/egyedi-04.jpg",
    "/assets/gallery/teherauto-01.jpg",
    "/assets/gallery/egyedi-05.jpg",
  ],
  awningGallery: [
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
  ],
  usedGallery: [
    "/assets/gallery/teherauto-02.jpg",
    "/assets/gallery/teherauto-03.jpg",
    "/assets/gallery/teherauto-04.jpg",
    "/assets/gallery/palletways-01.jpg",
    "/assets/gallery/palletways-02.jpg",
    "/assets/gallery/palletways-03.jpg",
    "/assets/gallery/palletways-04.jpg",
    "/assets/gallery/palletways-05.jpg",
    "/assets/gallery/palletways-06.jpg",
  ],
  customGallery: [
    "/assets/gallery/egyedi-01.jpg",
    "/assets/gallery/egyedi-02.jpg",
    "/assets/gallery/egyedi-03.jpg",
    "/assets/gallery/egyedi-04.jpg",
    "/assets/gallery/palletways-07.jpg",
    "/assets/gallery/teherauto-01.jpg",
    "/assets/gallery/egyedi-05.jpg",
    "/assets/gallery/teherauto-02.jpg",
  ],
  poolGallery: [
    "/assets/gallery/medence.jpg",
    "/assets/gallery/medence.jpg",
    "/assets/gallery/medence.jpg",
    "/assets/gallery/medence.jpg",
    "/assets/gallery/medence.jpg",
    "/assets/gallery/teherauto-03.jpg",
  ],
  ironGallery: [
    "/assets/gallery/egyedi-01.jpg",
    "/assets/gallery/teherauto-04.jpg",
    "/assets/gallery/egyedi-02.jpg",
    "/assets/gallery/egyedi-03.jpg",
    "/assets/gallery/egyedi-04.jpg",
    "/assets/gallery/palletways-01.jpg",
  ],
  terraceWinterGallery: [
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
    "/assets/gallery/terasz-telisites.jpg",
  ],
  garageGallery: [
    "/assets/gallery/egyedi-05.jpg",
    "/assets/gallery/egyedi-01.jpg",
    "/assets/gallery/egyedi-02.jpg",
  ],
  upholsteryGallery: [
    "/assets/gallery/egyedi-03.jpg",
    "/assets/gallery/egyedi-04.jpg",
    "/assets/gallery/egyedi-05.jpg",
    "/assets/gallery/palletways-02.jpg",
    "/assets/gallery/palletways-03.jpg",
    "/assets/gallery/palletways-04.jpg",
  ],
  printGallery: [
    "/assets/gallery/nyomtato.webp",
    "/assets/gallery/lasi-02.jpg",
    "/assets/gallery/lasi-03.jpg",
    "/assets/gallery/palletways-05.jpg",
  ],
};

// 20+ year company history milestones for /rolunk page
export const HISTORY = [
  { year: "2003", title: "Alapítás", text: "Megalakult a Fortuna Ponyva, kezdetben helyi fuvarozók kiszolgálására." },
  { year: "2009", title: "Dunaharaszti telephely", text: "Költözés a jelenlegi modern, könnyen megközelíthető telephelyre az M0 mellett." },
  { year: "2012", title: "Reklámdekoráció", text: "Reklámrészlegünk saját gépparkkal bővül." },
  { year: "2021", title: "Bővülés", text: "Új telephely kialakítása 600 m-re, a Jedlik Ányos út 20. szám alatt." },
  { year: "2026", title: "20+ év, 5000+ ponyva", text: "Több ezer hazai és nemzetközi ügyfél, két évtizednyi tapasztalattal." },
];
